// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1vbGy","inner":"Form_inner__1eeTj","range":"Form_range__3aOY9","name":"Form_name__1Az45","actions":"Form_actions__2-Dv3"};